import * as React from 'react';
import { Modal, Form, Input, Switch, Button, Divider } from 'antd';
// import { PlusOutlined } from '@ant-design/icons';
import 'antd/dist/antd.css';

import DragSortingUpload from '../../../components/DragSortingUpload';

export default function AddSKUModal(props) {
  const [form] = Form.useForm();
  const [title, setTitle] = React.useState('');

  const formItemLayout = {
    labelCol: {
      span: 4,
    },
    wrapperCol: {
      span: 18,
    },
  };
  const normFile = (e) => {
    if (Array.isArray(e)) {
      return e;
    }

    return e && e.fileList;
  };

  React.useEffect(() => {
    if (
      props.skuItem && // 👈 null and undefined check
      Object.keys(props.skuItem).length === 0 &&
      Object.getPrototypeOf(props.skuItem) === Object.prototype
    ) {
      setTitle('Add new SKU');
      form.resetFields();
    } else {
      setTitle('Edit SKU');
      form.setFieldsValue(props.skuItem);
      // console.log(form.getFieldValue('skuImageFiles'), 'when set field value call');
    }
  }, [props.skuItem]);

  return (
    <Modal {...props} footer={null} title={title}>
      <Form name='edit_sku' form={form} {...formItemLayout} onFinish={props.onFinish}>
        <Form.Item
          noStyle
          shouldUpdate={(prevValues, currentValues) => {
            // console.log(prevValues, 'prevValue');
            // console.log(currentValues, 'cur value');
            return prevValues !== currentValues;
          }}>
          {({ getFieldValue }) => {
            // console.log(getFieldValue('skuImageFiles'));
            return (
              <Form.Item label='ภาพ SKU' name='skuImageFiles' valuePropName='fileList' getValueFromEvent={normFile}>
                <DragSortingUpload maxCount={1} fileList={getFieldValue('skuImageFiles')} />
              </Form.Item>
            );
          }}
        </Form.Item>

        <Form.Item
          name='skuName'
          label='ชื่อสินค้าย่อย'
          required
          rules={[{ required: true, message: 'กรุณาระบุชื่อสินค้าย่อย' }]}>
          <Input placeholder='ชื่อสินค้า' />
        </Form.Item>
        <Form.Item name='sku' label='เลข SKU'>
          <Input showCount placeholder='เลข sku' />
        </Form.Item>
        <Form.Item
          name='mainPrice'
          label='ราคาตั้ง'
          required
          rules={[
            { required: true, message: 'กรุณาระบุราคาตั้ง' },
            { pattern: new RegExp(/^[0-9]+$/), message: 'กรอกเป็นตัวเลขเท่านั้น' },
          ]}>
          <Input placeholder='ราคาปกติ' />
        </Form.Item>
        <Form.Item
          name='discountPrice'
          label='ราคาลด'
          rules={[{ pattern: new RegExp(/^[0-9]+$/), message: 'กรอกเป็นตัวเลขเท่านั้น' }]}>
          <Input placeholder='ราคาลด' />
        </Form.Item>
        <Form.Item name='inStock' label='มีสินค้า?' valuePropName='checked'>
          <Switch />
        </Form.Item>

        <Divider />

        <Form.Item
          wrapperCol={{
            span: 6,
            offset: 10,
          }}
          style={{ marginBottom: 0 }}>
          <Button style={{ width: 100 }} type='primary' htmlType='submit'>
            Submit
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
}
